import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DropdownMenu, { MenuOption } from '../Menu/DropdownMenu';
import { ContactUsForm } from '../ContactUs/ContactUsForm';
import Dialog from '@mui/material/Dialog';
import { DialogContent } from '@mui/material';

interface PortalSupportMenuProps {
  // Follows the docs_viewer flag, so the menu never offers a page that would not render.
  showDocs?: boolean;
}

export const PortalSupportMenu = ({ showDocs = false }: PortalSupportMenuProps) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const docsOption: MenuOption = { fontColor: 'indigo', onClick: () => navigate('/docs'), title: 'Docs' };
  const menuOptions: MenuOption[] = [
    { fontColor: 'grey9', onClick: () => {}, title: 'Portal Support' },
    ...(showDocs ? [docsOption] : []),
    { fontColor: 'indigo', onClick: () => setOpen(true), title: 'Contact Portal Support' }
  ];

  const onClose = async () => {
    setOpen(false);
  };

  return (
    <div
      className="fixed right-3 bottom-3 z-50"
      data-testid="portal-support-menu">
      <DropdownMenu
        anchorOriginVertical="top"
        transformOriginVertical="bottom"
        icon="questionIcon"
        buttonText=""
        options={menuOptions}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: -1,
              ml: 0.7,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 110,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0
              }
            },
            style: {
              width: 200
            }
          }
        }}
      />
      <Dialog
        open={open}
        sx={{
          height: '50rem'
        }}
        onClose={() => setOpen(false)}
        data-testid="edit-account-settings-modal">
        <DialogContent sx={{ width: '400px' }}>
          <ContactUsForm onClose={onClose} />
        </DialogContent>
      </Dialog>
    </div>
  );
};
